/**
 * SessionExpiredModal - 세션 만료 모달
 *
 * 인증 토큰이 만료되었을 때 사용자에게 재로그인을 유도하는 모달입니다.
 */

interface SessionExpiredModalProps {
  /**
   * 모달 표시 여부
   */
  isOpen: boolean

  /**
   * 재로그인 버튼 클릭 핸들러
   */
  onRelogin: () => void
}

/**
 * SessionExpiredModal 컴포넌트
 */
export function SessionExpiredModal({ isOpen, onRelogin }: SessionExpiredModalProps) {
  if (!isOpen) return null

  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 backdrop-blur-sm">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-2xl w-full max-w-md mx-4 p-6">
        {/* 아이콘 */}
        <div className="flex justify-center mb-4">
          <div className="w-16 h-16 bg-amber-100 dark:bg-amber-900/30 rounded-full flex items-center justify-center">
            <svg
              className="w-8 h-8 text-amber-600 dark:text-amber-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>
        </div>

        {/* 제목 */}
        <h2 className="text-xl font-bold text-center text-gray-900 dark:text-gray-100 mb-2">
          세션이 만료되었습니다
        </h2>

        {/* 설명 */}
        <p className="text-center text-gray-600 dark:text-gray-400 mb-6">
          보안을 위해 일정 시간이 지나면 로그인이 만료됩니다.
          <br />
          계속 사용하시려면 다시 로그인해주세요.
        </p>

        {/* 재로그인 버튼 */}
        <button
          onClick={onRelogin}
          className="w-full px-4 py-3 bg-primary-600 text-white rounded-lg
                   hover:bg-primary-700 transition-colors font-medium
                   focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
        >
          다시 로그인하기
        </button>

        {/* 안내 */}
        <p className="text-xs text-center text-gray-500 dark:text-gray-500 mt-4">
          로그인하시면 작업하시던 내용은 자동으로 복원됩니다
        </p>
      </div>
    </div>
  )
}
